import { Component, OnInit ,NgZone } from '@angular/core';
import { Router,RouterOutlet, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BaseComponent } from './share/component/base.component';
declare var $;
declare var Swiper;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent extends BaseComponent implements OnInit  {

  // public menuOpen = false;
  // public IsMobile = false;
  // public topStyle = {bottom:'4.5rem',right:'0.5rem'};
  public copyRightY:any = '2023';
  public loginSubscrib;
  public iscookie = false;
  constructor(
    public router: Router,
    public ngzone: NgZone
  ) {
    super(); //繼承實例化
    if(this.jslib.ClientWidth() < 768){
      this.IsMobile = true;
    }else{
      this.IsMobile = false;
    }
    //若手機版有cookie政策 需往上推
    var isCookie = this.jslib.GetStorage('cookie');
    if(isCookie != false){
      this.iscookie = true;
    }
  }

  public menuData;//主選單
  public topmenu;//上選單
  public Member;
  public Login = false;
  ngOnInit() {
    //切頁畫面重置
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      var _url = evt.url;
      // if(_url.indexOf('/member/') > -1){
      //   if(!this.baseApi.IsLogin()){
      //     this.baseApi.RedirectSSO();
      //   }
      // }
      //console.log('route change',_url);
      //Close any Pop
      this.pop.setConfirm(false);
      //this.AddHistory(evt.url);
      // if(evt.url == '/home' && this.IsMobile){
      //   this.topStyle.right = '-8rem';
      // }else{
      //   this.topStyle.right = '0.5rem';
      // }
      //console.log('rChange scroll!!',evt);
      //分頁網址變化不滾動至頂
      if(evt.url.indexOf('?page=') == -1){
        window.scrollTo(0, 0);
      }
      //this.menuOpen = false;
    });
    //back event
    this.ngzone.runOutsideAngular(()=>{

        $(window).scroll(function(){
          if ($(this).scrollTop() > 100) {
              $('#top').fadeIn();
          } else {
              $('#top').fadeOut();
          }
          //detect scroll fixed
          var _fixed = document.getElementById("scrollfix");
          var _ismobile = (this.jslib.ClientWidth() < 768);
          if(_fixed){
            var _top = $(this).scrollTop();
            if (_top > 120 && !_ismobile) {
              _fixed.className = "fixed";
            } else {
              _fixed.className = "";
            }
            // var vh = window.innerHeight;
            // if(vh > 1200){
            //   var _h = this.jslib.ClientHeight();
            //   //body高 - 滾動高 - 視窗高 - footer高
            //   var _bottom = (_h - _top - window.innerHeight -257);
            //   if(_bottom < 0){
            //     _fixed.className = "bottom";
            //   }
            //   //console.log('bottom',_bottom);
            // }
            if(!_ismobile){
              var _w = $('.col-12.header').width();
              _fixed.style.width = ((_w*0.25) -8) +'px';
              var _h = this.jslib.ClientHeight();
              var _f = $('footer').outerHeight(true);
              var _b = $('#scrollfix').outerHeight(true)
              var _bottom = (_h - _f - _b - 128);
              if(_top > _bottom){
                //console.log('className bottom',top ,_bottom);
                _fixed.className = "bottom";
              }
            }
          }
      });
      $('#top').click(function () {
          $("html, body").animate({
              scrollTop: 0
          }, 600);
          return false;
      });
    });

    var tempW = this.jslib.ClientWidth();
    //resize reload
    $(window).resize(function() {
      var nowW = this.jslib.ClientWidth();
      if(tempW > 768 && nowW <= 768){
        tempW = nowW;
        window.location.reload();
      }
      if(tempW < 768 && nowW >= 768){
        tempW = nowW;
        window.location.reload();
      }

      //detect scroll fixed
      var _fixed = document.getElementById("scrollfix");
      var _ismobile = (this.jslib.ClientWidth() < 768);
      if(_fixed){
        if(!_ismobile){
          var _w = $('.col-12.header').width();
          _fixed.style.width = ((_w*0.25) -8) +'px';
        }
      }
    });

    // setTimeout(function(){
    //   //搜尋按鈕
    //   $('.mSearch').click(function(){
    //     $('#mSearch_bar').animate({left:"0",opacity:"100"});
    //    });

    //    $('#mSearchback').click(function(){
    //    $('#mSearch_bar').animate({left:"100%",opacity:"0"});
    //    });
    // },250);

    //訂閱偵測登入事件
    this.loginSubscrib = this.baseApi.eventUpdated.subscribe(
      (user) => {
        //console.log('loginSubscrib!!');
        var _login = (user != null);
        if(_login != this.Login){
          this.Login = _login;
          if(this.Login){
            //console.log('Login');
            this.Member = this.baseApi.GetUser();
            this.CheckPwdStatus(true);
          }else{
            //console.log('LogOut');
            this.Member = null;
            this.CheckPwdStatus(false);
          }
        }
      }
    );

    this.copyRightY = new Date().getFullYear();
  }

  AddHistory(url){
    var list = this.jslib.GetStorage('history');
    list =  (list) ? list : [];
    list.push(url);
    //keep 10
    if(list.length > 10){
      list = list.slice(1);
    }
    this.jslib.SetStorage('history',list);
  }

  public languages;
  GetLang(){
   return this.baseApi.apiGet('home/lang',{});
  }
  public seo;
  public webtitle;
  GetSeo(){
    this.baseApi.apiGet('home/seo',{}).then(
      (res)=>{

       this.seo = res;
       this.setMetaTtitle(res['title']);

       this.setMeta('description',res['description']);
       this.setMeta('keywords',res['keywords']);
      },(err)=>{
    });
  }
  public Socialurl;
  GetSocialurl(){
    this.baseApi.apiGet('home/socialurl',{}).then(
      (res)=>{
      // //console.log('Socialurl',res);
       this.Socialurl = res;
       var allvalue = Object.values(res);
      },(err)=>{
    });
  }

  moreShow = false;
  GetMenu(){
    this.menuData = [];
    this.topmenu = [];
    this.baseApi.apiGet('home/menu',{}).then(
      (res)=>{
        this.menuData = this.RouteHandler(res);
        this.topmenu = this.menuData.slice(0, 6);
        if(this.menuData.length > 6){
           this.moreShow = true;
        }
      },(err)=>{
    });
  }

  RouteHandler(menuObj){
    menuObj.forEach(item => {
      item.link = this.RouteMap(item.link);
       if(item.sub && item.sub.length > 0){
        item.sub.forEach(_s => {
            _s.link = this.RouteMap(_s.link);
        });
       }
    });
    return menuObj;
  }
  //網址轉換
  RouteMap(menuUrl){
    var hosturl = window.location.protocol + '//' + window.location.host;
    if(typeof menuUrl == 'number'){
      menuUrl = '' + '/note/detail?id=' + menuUrl;
      return menuUrl;
    }else{
      if(menuUrl == null){
        return '';
      }
      menuUrl = menuUrl.replace(hosturl,'');
      menuUrl = menuUrl.replace('/news/index.jsp','/news/list');
      menuUrl = menuUrl.replace('/event/index.jsp','/event/list');
      menuUrl = menuUrl.replace('/note.jsp','/note/detail');
      menuUrl = menuUrl.replace('/about/newhandler.do','/contactUs');
      menuUrl = menuUrl.replace('/business/update.jsp','/trade');
      return menuUrl;
    }
  }
  public IsMenu = false;
  MenuToggle(){
    this.IsMenu = !this.IsMenu;
  }
  Mask(event){
    this.IsMenu = !this.IsMenu;
    event.preventDefault();
    event.stopPropagation();
    return;
  }
  UserLogin(){
    this.baseApi.RedirectSSO();
  }
  LoginConfirm(tempUrl){
    if(tempUrl){
      this.jslib.SetStorage('tempUrl',tempUrl);
    }
    this.pop.setConfirm({
      content:'請先登入',
      checkTxt:'前往登入',
      cancelTxt:'取消',
      event:()=>{
        this.baseApi.RedirectSSO();
      }
    });
  }
  UserLogout(){
    this.pop.setConfirm({
      content:'您是否要登出?',
      checkTxt:'確認',
      cancelTxt:'取消',
      event:()=>{
        this.baseApi.SSOLogout();
      }
    });
  }

  private interval;
  CheckPwdStatus(status){
    if(status && !this.interval){
      this.interval = setInterval(() => {
        this.CheckPwdChange();
      },(60*1000));
    }
    if(status == false){
      if (this.interval) {
          clearInterval(this.interval);
      }
    }
  }
  CheckPwdChange(){
    //未上正式
    // this.baseApi.apiPost('v1/member/check/password',{},true).then((res)=>{
    //   console.log('觸發 CheckPwdChange',res);
    //   var status = res['status'];//status: 0=不動作、1=通知、2=登出
    //   if(status == '1'){
    //     this.pop.setConfirm({
    //       content:'此帳號密碼已被修改，請於10分鐘內以新密碼重新登入，否則系統將逕行登出。',
    //       checkTxt:'我知道了'
    //     });
    //   }
    //   if(status == '2'){
    //     this.pop.setConfirm({
    //       content:'此帳號密碼已被修改，請以新密碼重新登入。',
    //       checkTxt:'我知道了',
    //       event:()=>{
    //         this.baseApi.SSOLogout();
    //       }
    //     });
    //   }
    // });
  }

  ngOnDestroy() {
    this.loginSubscrib.unsubscribe();
  }
}
